import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useFooterSettings = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.FOOTER_SETTINGS(),
    queryFn: () => shopApi.fetchFooterSettings(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.FOOTER_SETTINGS(),
    });
  };

  return {
    isLoading,
    isFetching,
    footerSettings: data?.data,
    invalidate,
  };
};
